import { type SignUpMethod } from 'src/api';

export const EmployeeSettingsFormFields = {
  signUpMethod: 'signUpMethod',
  pinHint: 'pinHint',
  isLive: 'isLive',
} as const;

export type EmployeeSettingsFormValues = {
  [EmployeeSettingsFormFields.signUpMethod]: SignUpMethod;
  [EmployeeSettingsFormFields.pinHint]?: string | null;
  [EmployeeSettingsFormFields.isLive]: boolean;
};
